import React, { Component } from 'react';
import { Dropdown, MenuItem } from 'react-bootstrap';
import { RootCloseWrapper } from 'react-overlays';
import loadingImage from '../img/loading.svg'

class GroupedByLoading extends Component {
  render() {
    if(this.props.loadingState){
      return (
        <div className='grouped-reports-loading'>
          <div>
            <img src={loadingImage} alt="loading" />
          </div>
          <h5 className="loading-text">
            در حال دسته بندی داده ها...
          </h5>
        </div>
      );
    }
    else{
      return null;
    }
  }
}


class CustomToggle extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    this.props.onClick(e);
  }

  render() {
    return (
      <div className = { (this.props.openState ? 'open-menu ' : '') + 'dropdown-btn' } onClick={this.handleClick}>
        {this.props.children}
      </div>
    );
  }
}

class CustomMenu extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      value: '',
    };

    this.setGroup = this.setGroup.bind(this);
  }

  setGroup ( layerNumber , group ) {
    this.props.setGroupBy(layerNumber,group);
  }

  render() {
    const { groupBy } = this.props;
    let subgroup = [{en:'name',fa:'عنوان'},{}];
    if(groupBy[0].en === 'project'){
      subgroup[1] = {en:'user',fa:'کاربر'};
    }
    else{
      subgroup[1] = {en:'project',fa:'پروژه'};
    }

    return (
      <div className="dropdown-menu group-menu" >
        <ul className="group-list">
          <MenuItem className="filter-controller row"   >
            <div className="checkbox-container col-sm-2">
              <input className="checkbox-input" type="checkbox" onChange={ ()=>{} } checked={ groupBy[0].en === 'project' || false } id="group-project-checkbox" />
            </div>
            <div className="label-container col-sm-6" onClick={ () => {  this.setGroup(0,{en:'project',fa:'پروژه'}); this.props.toggleMenu(); } } >
              <label className="checkbox-label" htmlFor="group-project-checkbox">
                پروژه
              </label>
            </div> 
          </MenuItem>
          <MenuItem className="filter-controller row" >
          <div className="checkbox-container col-sm-2">
            <input className="checkbox-input" type="checkbox" onChange={()=>{}} checked={ groupBy[0].en === 'user' || false } id="group-user-checkbox" />
          </div>
          <div className="label-container col-sm-6" onClick={ () => { this.setGroup(0,{en:'user',fa:'کاربر'}); this.props.toggleMenu(); } } >
            <label className="checkbox-label" htmlFor="group-user-checkbox">
              کاربر
            </label>
          </div>
          </MenuItem>
          <MenuItem className="filter-controller filter-header" header  > زیرگروه ها </MenuItem>
          <MenuItem className="filter-controller row"  >
          <div className="checkbox-container col-sm-2">
            <input className="checkbox-input" type="checkbox" onChange={()=>{}} checked={ groupBy[1].en === 'name' || false } id="subgroup1-checkbox" />
          </div>
          <div className="label-container col-sm-6" onClick={ () => { this.setGroup(1,subgroup[0]); this.props.toggleMenu(); } }>
            <label className="checkbox-label" htmlFor="subgroup1-checkbox">
              { subgroup[0].fa }
            </label>
          </div>
          </MenuItem>
          <MenuItem className="filter-controller row"  >
          <div className="checkbox-container col-sm-2">
            <input className="checkbox-input" type="checkbox" onChange={()=>{}} checked={ groupBy[1].en === subgroup[1].en || false } id="subgroup2-checkbox" />
          </div>
          <div className="label-container col-sm-6" onClick={ () => { this.setGroup(1,subgroup[1]); this.props.toggleMenu(); } } >
            <label className="checkbox-label" htmlFor="subgroup2-checkbox">
              { subgroup[1].fa }
            </label>
          </div>
          </MenuItem>
        </ul>
      </div>
    );
  }
}

export class GroupFilter extends Component {
  constructor(props, context) {
    super(props, context); 
    this.state = {
      open: false
    };
    this.toggleOpenState = this.toggleOpenState.bind(this)   
    this.setOpenStateToFalse = this.setOpenStateToFalse.bind(this)   
  }
  
  setOpenStateToFalse() {
    this.setState({open : false});
  }

  toggleOpenState() {
    this.setState({open : !this.state.open});
  }

  render(){
    
    return (
    <RootCloseWrapper onRootClose={this.setOpenStateToFalse}>
      <Dropdown open={this.state.open} onToggle={this.toggleOpenState} id="dropdown-custom-menu" >
      <GroupedByLoading loadingState={this.props.loadingState} />      
        <CustomToggle openState={this.state.open} bsRole="toggle"  >
          <span className="small-text-span" >
            گروه بندی شده بر اساس
          </span>
          <span className='bold-text-span' >
            {' ' + this.props.groupBy[0].fa + ' / ' + this.props.groupBy[1].fa }
          </span>
          <span className="caret" /> 
        </CustomToggle>

        <CustomMenu toggleMenu={this.toggleOpenState}  bsRole="menu" setGroupBy={this.props.setGroupBy} groupBy={this.props.groupBy}  />
      </Dropdown>
    </RootCloseWrapper>)
  }
}